import React, { useState } from 'react';

const slides = [
  {
    icon: 'bi-collection-play',
    title: 'Selamat Datang di Conexsee! 🎉',
    subtitle: 'Platform pembelajaran kelas Anda',
    content: (
      <div>
        <p>Setelah berhasil melakukan pembayaran kelas, Anda dapat mengakses seluruh materi pembelajaran di sini.</p>
        <p className="mb-0">Berikut panduan singkat fitur-fitur yang tersedia untuk Anda:</p>
      </div>
    ),
  },
  {
    icon: 'bi-grid-1x2',
    title: 'Kelas Saya',
    subtitle: 'Daftar kelas yang telah Anda beli',
    content: (
      <div>
        <p>Di halaman <strong>Kelas Saya</strong>, Anda dapat melihat:</p>
        <ul>
          <li>Semua kelas yang sudah dibayar</li>
          <li><strong>Progress bar</strong> — menunjukkan persentase episode yang sudah diselesaikan</li>
          <li>Status sertifikat — jika sudah tersedia, badge hijau akan muncul</li>
        </ul>
        <p className="mb-0">Klik tombol <strong>"Mulai Belajar"</strong> atau <strong>"Lanjutkan Belajar"</strong> untuk masuk ke halaman pembelajaran.</p>
      </div>
    ),
  },
  {
    icon: 'bi-play-circle',
    title: 'Episode',
    subtitle: 'Daftar sesi kelas',
    content: (
      <div>
        <p>Di bagian <strong>Episode</strong>, Anda dapat:</p>
        <ul>
          <li>Melihat daftar semua episode/sesi kelas</li>
          <li>Menonton video rekaman kelas</li>
          <li>Menandai episode sebagai <strong>"Selesai"</strong> setelah ditonton</li>
        </ul>
        <p className="mb-0">Episode yang sudah selesai akan ditandai dengan ikon <span className="badge bg-success">✓</span>. Progress Anda akan tersimpan otomatis.</p>
      </div>
    ),
  },
  {
    icon: 'bi-file-earmark-text',
    title: 'Materi',
    subtitle: 'File pendukung pembelajaran',
    content: (
      <div>
        <p>Di bagian <strong>Materi</strong>, Anda dapat:</p>
        <ul>
          <li>Melihat daftar materi pendukung (PDF, dokumen, presentasi, gambar)</li>
          <li><strong>Mengunduh (download)</strong> materi yang tersedia</li>
          <li>Melihat jenis file dari ikon yang ditampilkan</li>
        </ul>
        <p className="mb-0">Klik tombol <strong>"Download"</strong> untuk menyimpan materi ke perangkat Anda.</p>
      </div>
    ),
  },
  {
    icon: 'bi-journal-text',
    title: 'Transkrip',
    subtitle: 'Teks lengkap kelas',
    content: (
      <div>
        <p>Di bagian <strong>Transkrip</strong>, Anda dapat:</p>
        <ul>
          <li>Membaca transkrip lengkap dari setiap sesi kelas</li>
          <li>Memilih transkrip per episode melalui dropdown</li>
        </ul>
        <p className="mb-0">Seluruh teks transkrip ditampilkan dalam satu halaman sehingga mudah dibaca dan dicari.</p>
      </div>
    ),
  },
  {
    icon: 'bi-patch-question',
    title: 'Kuis',
    subtitle: 'Uji pemahaman Anda',
    content: (
      <div>
        <p>Di bagian <strong>Kuis</strong> (jika tersedia), Anda dapat:</p>
        <ul>
          <li>Mengerjakan soal <strong>pilihan ganda</strong> (satu jawaban benar)</li>
          <li>Mengerjakan soal <strong>multi jawaban</strong> (beberapa jawaban benar)</li>
          <li>Melihat nilai dan status kelulusan setelah submit</li>
        </ul>
        <p className="mb-0">Jika belum lulus, Anda dapat mengulang kuis kembali. Nilai kelulusan ditentukan oleh admin.</p>
      </div>
    ),
  },
  {
    icon: 'bi-award',
    title: 'Sertifikat',
    subtitle: 'Penghargaan setelah menyelesaikan pembelajaran',
    content: (
      <div>
        <p>Di bagian <strong>Sertifikat</strong>, Anda dapat:</p>
        <ul>
          <li>Melihat persyaratan untuk mendapatkan sertifikat</li>
          <li>Memantau progres penyelesaian episode</li>
          <li><strong>Mengunduh sertifikat</strong> setelah semua persyaratan terpenuhi</li>
        </ul>
        <p className="mb-0">Sertifikat akan otomatis terbit setelah Anda menyelesaikan semua episode dan/atau lulus kuis (sesuai ketentuan kelas).</p>
      </div>
    ),
  },
  {
    icon: 'bi-whatsapp',
    title: 'Butuh Bantuan?',
    subtitle: 'Kami siap membantu',
    content: (
      <div>
        <p>Jika Anda mengalami kendala atau memiliki pertanyaan:</p>
        <ul>
          <li>Klik ikon <span style={{color: '#25D366'}}><strong>WhatsApp</strong></span> di pojok kanan bawah</li>
          <li>Kirim pesan ke admin kami</li>
          <li>Tim support akan merespon secepatnya</li>
        </ul>
        <p className="mb-0 text-center fw-bold">Selamat belajar dan semoga sukses! 🚀</p>
      </div>
    ),
  },
];

export default function GuideBook({ show, onClose }) {
  const [step, setStep] = useState(0);

  if (!show) return null;

  const slide = slides[step];
  const isLast = step === slides.length - 1;
  const isFirst = step === 0;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '16px' }}>
          {/* Header */}
          <div className="modal-header border-0 pb-0">
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>

          {/* Body */}
          <div className="modal-body text-center px-5 pt-2 pb-4">
            {/* Step indicator */}
            <div className="d-flex justify-content-center gap-1 mb-4">
              {slides.map((_, i) => (
                <div
                  key={i}
                  className="rounded-pill"
                  style={{
                    width: i === step ? '24px' : '8px',
                    height: '8px',
                    backgroundColor: i === step ? '#F68D6E' : i < step ? '#198754' : '#dee2e6',
                    transition: 'all 0.3s ease',
                  }}
                />
              ))}
            </div>

            {/* Icon */}
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '20px',
                backgroundColor: '#fff3e0',
              }}
            >
              <i className={`bi ${slide.icon}`} style={{ fontSize: '2.5rem', color: '#F68D6E' }}></i>
            </div>

            {/* Title */}
            <h4 className="fw-bold mb-1">{slide.title}</h4>
            <p className="text-muted mb-3">{slide.subtitle}</p>

            {/* Content */}
            <div className="text-start" style={{ fontSize: '0.95rem' }}>
              {slide.content}
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer border-0 pt-0 justify-content-between">
            <div>
              {!isFirst && (
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setStep(s => Math.max(0, s - 1))}
                >
                  <i className="bi bi-chevron-left me-1"></i>Sebelumnya
                </button>
              )}
            </div>
            <div>
              <small className="text-muted me-3">{step + 1} / {slides.length}</small>
              {isLast ? (
                <button className="btn btn-dark px-4" onClick={onClose}>
                  Mengerti <i className="bi bi-check-lg ms-1"></i>
                </button>
              ) : (
                <button
                  className="btn btn-dark px-4"
                  onClick={() => setStep(s => Math.min(slides.length - 1, s + 1))}
                >
                  Selanjutnya <i className="bi bi-chevron-right ms-1"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
